module.exports = __webpack_public_path__ + "img/ic_tripadvisor-4.5.fa4ec92a.svg";